// extracted by mini-css-extract-plugin
export default {"wrap":"RG-z","fullWidth":"SG-z","hideOnDesktop":"TG-z","content":"UG-z","hasOpenedNav":"VG-z","crumbsList":"WG-z","dropdownsWrap":"XG-z"};